import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NumberFormat from 'react-number-format';
import {httpClient} from "../../core/HttpClient";
import { useTranslation } from "react-i18next";
import Card from "@mui/material/Card";
import {getDatabase, goOffline, goOnline} from "firebase/database";
import { useIdleTimer } from 'react-idle-timer';
import {getDatabaseInstance} from "../../core/Firebase";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import AccountBilling from "../AccountBilling";

export default function AccountOrder() {
    const { t } = useTranslation();
    const [accountBill, setAccountBill] = useState({
        month: 0,
        salesVolume: 0,
        paymentAmount: 0,
        vat: 0,
        discount: 0,
        totalAmount: 0,
        status: 'PENDING',
    });
    const [openInfo, setOpenInfo] = useState(false);

    const onAction = (event) => {
        if(['visibilitychange','focus'].indexOf(event.type) > -1){
            if(document.visibilityState === 'hidden'){
                let app = getDatabaseInstance();
                const db = getDatabase(app);
                goOffline(db);
            } else if(document.visibilityState === 'visible'){
                let app = getDatabaseInstance();
                const db = getDatabase(app);
                goOnline(db);
            }
        }
    }

    useIdleTimer({
        onAction,
        timeout: 10_000,
        throttle: 500
    });

    useEffect(() => {
        console.log('[AccountOrder]');
        const url = process.env.REACT_APP_API_BASE_URL + '/accounts/me/bill';
        httpClient.get(url)
            .then(res => {
                if(res.data){
                    setAccountBill({
                        month: res.data.month,
                        salesVolume: res.data.salesVolume,
                        orderCount: res.data.orderCount,
                        paymentAmount: res.data.feeRate.fee,
                        vat: res.data.feeRate.vat,
                        discount: res.data.discount,
                        totalAmount: res.data.feeRate.total,
                        status: res.data.status,
                    });
                }
            });
    }, []);

    return (<Card variant="outlined">
            <Box m={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography color="textSecondary">
                        {accountBill.month > 0 && t('account.orderPerMonth', {month: t(`common.months.${accountBill.month}.name`)})} ({t('common.current')})
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="center">
                    <Table border={1} sx={{tableLayout: 'fixed', borderColor: 'grey.100'}} aria-label="SALES VOLUME">
                        <TableBody>
                            <TableRow>
                                <TableCell align="center" size="small">
                                    {t('invoice.totalAmount')}
                                </TableCell>
                                <TableCell align="center" size="small">
                                    {t('invoice.totalOrders')}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="center">
                                    <Typography variant="h6">
                                        <NumberFormat value={accountBill.salesVolume} displayType={'text'}
                                                      thousandSeparator={true}/> {t('invoice.baht')}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <Typography variant="h6">
                                        <NumberFormat value={accountBill.orderCount} displayType={'text'}
                                                      thousandSeparator={true}/> {t('invoice.unit')}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Box>
            </Box>
            <Box m={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography>
                        {t('pricing.commissionFee')}
                    </Typography>
                    <Typography color="success.main">
                        <NumberFormat value={accountBill.paymentAmount} displayType={'text'}
                                      thousandSeparator={true}/> {t('invoice.baht')}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography>
                        {t('pricing.vat')}
                    </Typography>
                    <Typography color="success.main">
                        <NumberFormat value={accountBill.vat} displayType={'text'}
                                      thousandSeparator={true}/> {t('invoice.baht')}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {t('common.grandTotal')}
                    </Typography>
                    <Typography variant="h6" color="success.main" sx={{ fontWeight: 'bold' }}>
                        <NumberFormat value={accountBill.totalAmount} displayType={'text'}
                                      thousandSeparator={true}/> {t('invoice.baht')}
                    </Typography>
                </Box>
            </Box>
            <Box mb={2}>
                <AccountBilling />
            </Box>
            <Dialog
                fullScreen={true}
                open={openInfo}
                aria-labelledby="info-modal-title"
                aria-describedby="info-modal-description"
                onClose={e => setOpenInfo(false)}
            >
                <AppBar position="static" color="transparent" elevation={0}>
                    <Toolbar variant="dense">
                        <Typography variant="h6" color="inherit" sx={{flexGrow: 1}}>
                            {t('common.info')}
                        </Typography>
                        <IconButton edge="start" color="primary" aria-label="black" onClick={e => setOpenInfo(false)}>
                            <CloseIcon/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Divider/>
                <DialogContent>
                    <Box>
                        <Typography>{t('pricing.pricingRate')}</Typography>
                    </Box>
                    <TableContainer>
                        <Table id="pricing-table" aria-label="simple table" sx={{border: '1px solid gainsboro'}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        align="center" style={{
                                        borderRight: '2px solid white',
                                        fontWeight: 'bold'
                                    }}>{t('pricing.commissionFee')}</TableCell>
                                    <TableCell
                                        align="center" style={{
                                        borderRight: '2px solid white',
                                        fontWeight: 'bold'
                                    }}>{t('pricing.income')}</TableCell>
                                    <TableCell align="center" style={{
                                        borderLeft: '2px solid white',
                                        fontWeight: 'bold'
                                    }}>{t('pricing.order')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R0.fee')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R0.income')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center" >
                                        <Box>{t('pricing.rateFee.R0.order')}</Box>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R1.fee')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R1.income')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center" >
                                        <Box>{t('pricing.rateFee.R1.order')}</Box>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R2.fee')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R2.income')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center" >
                                        <Box>{t('pricing.rateFee.R2.order')}</Box>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R3.fee')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R3.income')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center" >
                                        <Box>{t('pricing.rateFee.R3.order')}</Box>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R4.fee')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R4.income')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center" >
                                        <Box>{t('pricing.rateFee.R4.order')}</Box>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R5.fee')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center">
                                        <Box>{t('pricing.rateFee.R5.income')}</Box>
                                    </TableCell>
                                    <TableCell style={{borderRight: '1px solid gainsboro'}}
                                               align="center" >
                                        <Box>{t('pricing.rateFee.R5.order')}</Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box mt={2}>
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark')}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark1')}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark2')}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark3')}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant={"caption"}>
                                {t('pricing.remark4')}
                            </Typography>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
        </Card>
    )
}